export const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

export interface PatExpiration {
  isoDate: string;
  expiresInSeconds: number;
}

// Single Date.now() snapshot so isoDate and expiresInSeconds can't disagree under TZ/clock drift.
export function computePatExpiration(): PatExpiration {
  const expiresInSeconds = ONE_YEAR_IN_SECONDS;
  const expiresAt = new Date(Date.now() + expiresInSeconds * 1000);
  return {
    isoDate: expiresAt.toISOString(),
    expiresInSeconds,
  };
}
